export const PRICE_TYPE = {
  squareMeterMonthly: 'squareMeter_monthly',
  squareMeterAnnual: 'squareMeter_annual',
  allMonthly: 'all_monthly',
  squareMeter: 'squareMeter',
  all: 'all',
} as const;

export const RADIO_BUTTON_GROUP_OPTIONS_RENT = [
  {
    label: 'В месяц за м²',
    value: PRICE_TYPE.squareMeterMonthly,
  },
  {
    label: 'В год за м²',
    value: PRICE_TYPE.squareMeterAnnual,
  },
  {
    label: 'В месяц',
    value: PRICE_TYPE.allMonthly,
  },
];

export const RADIO_BUTTON_GROUP_OPTIONS_SALE = [
  {
    label: 'За м²',
    value: PRICE_TYPE.squareMeter,
  },
  {
    label: 'За всё',
    value: PRICE_TYPE.all,
  },
];
